export function getDisplayName(component) {
	return component.displayName || component.name || 'Component';
}

export function setDisplayName(component, wrapped) {
	component.displayName = `${getDisplayName(component)}(${getDisplayName(wrapped)})`;
}


// WEBPACK FOOTER //
// ./frontend/shared/react-hocs/hoc-helpers.js